import * as angular from 'angular';
import * as _ from 'lodash';

import { emailEventTypes } from '../../common';
import { ComponentDefinition } from '../../models/index';

class TriggerEventSelector implements angular.IComponentController {
    events: { value: number; name: string }[];
    isDisabled: boolean;
    model: string;
    
    static $inject = [];
    
    $onInit() {
        const events = [];
        for (const key of Object.keys(emailEventTypes)) {
            events.push({
                value: parseInt(key),
                name: emailEventTypes[key]
            });
        }
        this.events = events;
    }
}

export const wtTriggerEventSelector: ComponentDefinition = {
    componentId: 'wtTriggerEventSelector',
    controller: TriggerEventSelector,
    template: require('./triggerEventSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        isDisabled: '<?'
    }
};